import React from "react";

const DashboardCard = ({ heading, children }) => {
  return (
    <div className="w-100 rounded-4 p-4 grayCard ">
      <h2>
        <b> {heading} </b>
      </h2>
      {children}
    </div>
  );
};

export default DashboardCard;
